import { Row, Col, Modal } from "antd";
import { ArrowsAltOutlined, CloseOutlined } from "@ant-design/icons";
import Hold from "../../../../assets/images/pause-new.svg";
import Cancel from "../../../../assets/images/cancel-new.svg";
import styles from "../../../../constants/styles.json";
import useCartStore from "../../../../stores/useCartStore";
import useTransactionStore from "../../../../stores/useTransactionStore";

const SMCartSummary = ({
  cart,
  currenciesList,
  pricePrecision,
  themeJSON,
  isExchange,
  tempSaleTypeData,
  expandTotals,
  setExpandTotals,
  verifyStock,
  openDisplayParkedBillModal,
  deleteProductModal,
  toFixedTruncate,
}) => {
  const renderExchangeDiv = () => {
    const returnCart = cart || {};

    const exchangeCart = useCartStore.getState().exchangeCart || {};

    const returnTotal = parseFloat(returnCart?.total || 0);
    const exchangeTotal = parseFloat(exchangeCart?.total || 0);

    const netValue = parseFloat((returnTotal + exchangeTotal).toFixed(pricePrecision));
    return (
      <>
        <ArrowsAltOutlined
          style={{
            position: "absolute",
            top: "0px",
            right: "1px",
            cursor: "pointer",
            fontSize: "1.2vw",
            zIndex: 1,
          }}
          onClick={() => setExpandTotals(true)}
        />
        <Row style={{ height: "4.5vh" }}>
          <Col
            span={12}
            style={{
              display: "flex",
              alignItems: "center",
              paddingLeft: "0.8vw",
              textAlign: "left",
              fontWeight: "500",
              color: "#0F0718",
            }}
          >
            <p style={styles.screenStyles.mainScreen.subTotalText}>Old Value (Return):</p>
          </Col>
          <Col span={12} style={styles.screenStyles.mainScreen.subTotalCurrency}>
            {currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}
            &nbsp;
            <p
              style={{
                textAlign: "right",
                margin: "0",
                fontWeight: "500",
                color: "#0F0718",
              }}
            >
              {parseFloat(cart?.total ?? 0).toFixed(pricePrecision)}
            </p>
            <span style={{ marginLeft: "2px", marginTop: 0 }}>{currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""}</span>
          </Col>
        </Row>
        <Row style={{ height: "4.5vh" }}>
          <Col
            span={12}
            style={{
              display: "flex",
              alignItems: "center",
              paddingLeft: "0.8vw",
              textAlign: "left",
              fontWeight: "500",
              color: "#0F0718",
            }}
          >
            <p style={styles.screenStyles.mainScreen.subTotalText}>New Value (Exchange):</p>
          </Col>
          <Col span={12} style={styles.screenStyles.mainScreen.subTotalCurrency}>
            {currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}
            &nbsp;
            <p
              style={{
                textAlign: "right",
                margin: "0",
                fontWeight: "500",
                color: "#0F0718",
              }}
            >
              {parseFloat((useCartStore.getState().exchangeCart || {})?.total ?? 0).toFixed(pricePrecision)}
            </p>
            <span style={{ marginLeft: "2px", marginTop: 0 }}>{currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""}</span>
          </Col>
        </Row>
        <Row style={{ height: "4.5vh" }}>
          <Col
            span={12}
            style={{
              display: "flex",
              alignItems: "center",
              paddingLeft: "0.8vw",
              textAlign: "left",
              fontWeight: "500",
              color: "#0F0718",
            }}
          >
            <p style={styles.screenStyles.mainScreen.subTotalText}>Net Value:</p>
          </Col>
          <Col span={12} style={styles.screenStyles.mainScreen.subTotalCurrency}>
            {currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}
            &nbsp;
            <p
              style={{
                textAlign: "right",
                margin: "0",
                fontWeight: "500",
                color: "#0F0718",
              }}
            >
              {netValue}
            </p>
            <span style={{ marginLeft: "2px", marginTop: 0 }}>{currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""}</span>
          </Col>
        </Row>
        <Row style={{ height: "4.5vh" }}>
          <Col
            span={12}
            style={{
              display: "flex",
              alignItems: "center",
              paddingLeft: "0.8vw",
              textAlign: "left",
              fontWeight: "500",
              color: "#0F0718",
            }}
          >
            <p style={styles.screenStyles.mainScreen.subTotalText}>Total Items:</p>
          </Col>
          <Col span={12} style={styles.screenStyles.mainScreen.subTotalCurrency}>
            &nbsp;
            <p
              style={{
                textAlign: "right",
                margin: "0",
                fontWeight: "500",
                color: "#0F0718",
              }}
            >
              {/* {parseFloat((useCartStore.getState().exchangeCart || {})?.subTotal ?? 0).toFixed(pricePrecision)} */}
              {(useCartStore.getState().exchangeCart || {})?.items?.length || 0} / {parseFloat((useCartStore.getState().exchangeCart || {})?.totalQty || 0).toFixed(2)}
            </p>
          </Col>
        </Row>
      </>
    );
  };

  const renderTotalAmountText = () => {
    const returnCart = cart || {};
    const exchangeCart = useCartStore.getState().exchangeCart || {};

    const returnTotal = Math.abs(parseFloat(returnCart?.total || 0));
    const exchangeTotal = Math.abs(parseFloat(exchangeCart?.total || 0));

    const isExchangeMode = useTransactionStore.getState().selectedReturnType === "EXCHANGE";

    const isRefund = isExchangeMode && returnTotal > exchangeTotal;

    return (
      <p
        style={{
          padding: "0.7vw 0 0 1vw",
          color: "#fff",
          fontSize: "1em",
          fontWeight: "500",
          height: "4.5vh",
        }}
      >
        {isRefund ? "Refund Amount" : "Total Amount To Pay"}
      </p>
    );
  };

  return (
    <>
      <div style={{ padding: "0 1.5% 0 1.5%", display: "flex" }}>
        <div
          style={{
            background: themeJSON.taxAndDiscountSectionBGColor || "#fff",
            height: "23.5vh",
            width: "60%",
            marginRight: "1%",
            border: "1px solid #fff",
            borderRadius: "7px",
            padding: "0.5vh",
            fontSize: "1vw",
            position: "relative",
          }}
        >
          <>
            {!isExchange ? (
              <>
                {tempSaleTypeData?.length > 0 && (
                  <ArrowsAltOutlined
                    style={{
                      position: "absolute",
                      top: "0px",
                      right: "1px",
                      cursor: "pointer",
                      fontSize: "1.2vw", // optional: to scale appropriately
                      zIndex: 1, // ensures it's above content
                    }}
                    onClick={() => {
                      setExpandTotals(true);
                    }}
                  />
                )}
                <ArrowsAltOutlined
                  style={{
                    position: "absolute",
                    top: "0px",
                    right: "1px",
                    cursor: "pointer",
                    fontSize: "1.2vw", // optional: to scale appropriately
                    zIndex: 1, // ensures it's above content
                  }}
                  onClick={() => {
                    setExpandTotals(true);
                  }}
                />
                <Row style={{ height: "4.5vh" }}>
                  <Col
                    span={12}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      paddingLeft: "0.8vw",
                      textAlign: "left",
                      fontWeight: "500",
                      color: "#0F0718",
                    }}
                  >
                    <p style={styles.screenStyles.mainScreen.subTotalText}>Subtotal:</p>
                  </Col>
                  {/* <Col span={12} style={{ display: "flex", alignItems: "center", paddingRight: "0.8vw", textAlign: "right", justifyContent: "end", color: "#0F0718" }}> */}
                  <Col span={12} style={styles.screenStyles.mainScreen.subTotalCurrency}>
                    {currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}
                    &nbsp;
                    <p
                      style={{
                        textAlign: "right",
                        margin: "0",
                        fontWeight: "500",
                        color: "#0F0718",
                      }}
                    >
                      {/* {(
                            parseFloat(cart?.total ?? 0).toFixed(2) -
                            parseFloat(cart?.tax ?? 0).toFixed(2)
                          ).toFixed(2)} */}
                      {parseFloat(cart?.subTotal ?? 0).toFixed(pricePrecision)}
                    </p>
                    <span style={{ marginLeft: "2px", marginTop: 0 }}>{currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""}</span>
                  </Col>
                </Row>

                <Row style={{ height: "4.4vh" }}>
                  <Col
                    span={12}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      paddingLeft: "0.8vw",
                      fontWeight: "500",
                      textAlign: "left",
                    }}
                  >
                    <p style={styles.screenStyles.mainScreen.subTotalText}>Discount:</p>
                  </Col>
                  <Col span={12} style={styles.screenStyles.mainScreen.subTotalCurrency}>
                    {currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}
                    &nbsp;
                    <p
                      style={{
                        textAlign: "right",
                        margin: "0",
                        fontWeight: "500",
                        color: "#0F0718",
                      }}
                    >
                      {parseFloat(cart.discount ? cart.discount : 0).toFixed(pricePrecision)}
                    </p>
                    <span style={{ marginLeft: "2px" }}>{currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""}</span>
                  </Col>
                </Row>
                <Row style={{ height: "4.5vh" }}>
                  <Col
                    span={12}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      paddingLeft: "0.8vw",
                      fontWeight: "500",
                      textAlign: "left",
                    }}
                  >
                    <p style={styles.screenStyles.mainScreen.subTotalText}>Tax:</p>
                  </Col>
                  <Col span={12} style={styles.screenStyles.mainScreen.subTotalCurrency}>
                    {currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}
                    &nbsp;
                    <p
                      style={{
                        textAlign: "right",
                        margin: "0",
                        fontWeight: "500",
                        color: "#0F0718",
                      }}
                    >
                      {parseFloat(cart.tax).toFixed(pricePrecision)}
                    </p>
                    <span style={{ marginLeft: "2px" }}>{currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""}</span>
                  </Col>
                </Row>
                {cart.roundOff !== 0 && cart.roundOff !== undefined && (
                  <Row style={{ height: "4.5vh" }}>
                    <Col
                      span={12}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        paddingLeft: "0.8vw",
                        fontWeight: "500",
                        textAlign: "left",
                      }}
                    >
                      <p style={styles.screenStyles.mainScreen.subTotalText}>Round Off:</p>
                    </Col>
                    <Col span={12} style={styles.screenStyles.mainScreen.subTotalCurrency}>
                      {currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}
                      &nbsp;
                      <p
                        style={{
                          textAlign: "right",
                          margin: "0",
                          fontWeight: "500",
                          color: "#0F0718",
                        }}
                      >
                        {parseFloat(cart.roundOff).toFixed(pricePrecision)}
                      </p>
                      <span style={{ marginLeft: "2px" }}>{currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""}</span>
                    </Col>
                  </Row>
                )}
                <Row style={{ height: "4.5vh" }}>
                  <Col
                    span={12}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      paddingLeft: "0.8vw",
                      fontWeight: "500",
                      textAlign: "left",
                    }}
                  >
                    <p style={styles.screenStyles.mainScreen.subTotalText}>Net Value:</p>
                  </Col>
                  <Col span={12} style={styles.screenStyles.mainScreen.subTotalCurrency}>
                    {currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}
                    &nbsp;
                    <p
                      style={{
                        textAlign: "right",
                        margin: "0",
                        fontWeight: "500",
                        color: "#0F0718",
                      }}
                    >
                      {parseFloat(cart?.total ?? 0)?.toFixed(pricePrecision)}
                    </p>
                    <span style={{ marginLeft: "2px" }}>{currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""}</span>
                  </Col>
                </Row>

                <Row style={{ height: "4.5vh" }}>
                  <Col
                    span={12}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      paddingLeft: "0.8vw",
                      fontWeight: "500",
                      textAlign: "left",
                    }}
                  >
                    <p style={styles.screenStyles.mainScreen.subTotalText}>Total Items / Total Qty:</p>
                  </Col>
                  <Col span={12} style={styles.screenStyles.mainScreen.subTotalCurrency}>
                    <p
                      style={{
                        textAlign: "right",
                        margin: "0",
                        fontWeight: "500",
                        color: "#0F0718",
                      }}
                    >
                      {cart.items.length} / {parseFloat(cart.totalQty).toFixed(2)}
                    </p>
                  </Col>
                </Row>
              </>
            ) : (
              <>{renderExchangeDiv()}</>
            )}
          </>
        </div>
        <div style={{ height: "23.7vh", width: "40%", fontSize: "1vw" }}>
          <div
            id="sm-cart-total"
            // onClick={handleCartTotalClick}
            onClick={verifyStock}
            style={{
              height: "18.2vh",
              position: "relative",
              background: themeJSON.totalAmountToPaySectionBGColor || "#2F3856",
              borderRadius: "7px",
              cursor: "pointer",
            }}
          >
            {renderTotalAmountText()}
            {cart.total !== undefined ? (
              <p
                style={{
                  textAlign: "center",
                  color: "#fff",
                  fontSize: "2.5em",
                  fontWeight: "500",
                  height: "14.4vh",
                  width: "100%",
                  alignItems: "flex-start",
                  paddingTop: "1.2vh",
                }}
              >
                {" "}
                {/* {parseFloat(cart?.total ?? 0)?.toFixed(pricePrecision)} */}
                {((Number(cart?.total) || 0) + (Number((useCartStore.getState().exchangeCart || {})?.total) || 0)).toFixed(pricePrecision)}
              </p>
            ) : (
              <p
                style={{
                  textAlign: "center",
                  color: "#fff",
                  fontSize: "2.5em",
                  fontWeight: "500",
                  height: "14.4vh",
                  width: "100%",
                }}
              >
                {" "}
                0.00
              </p>
            )}
          </div>
          <Row gutter={[8, 0]} style={{ marginTop: "0.8vh" }}>
            <Col span={12} onClick={openDisplayParkedBillModal}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontWeight: "500",
                  textAlign: "left",
                  border: `1px solid ${themeJSON.holdAndCancelButtonBGColor || "rgba(146, 144, 152, 0.5)"}`,
                  height: "4.8vh",
                  borderRadius: "5px",
                  cursor: "pointer",
                  backgroundColor: themeJSON.holdAndCancelButtonBGColor || "#fff",
                }}
              >
                <img src={Hold} style={{ height: "2.5vh" }} />
                <span
                  style={{
                    margin: "0",
                    textAlign: "center",
                    color: themeJSON.holdAndCancelButtonTextColor || "#2F3856",
                    paddingLeft: "0.5vw",
                    fontSize: "1em",
                    fontWeight: 500,
                  }}
                >
                  Hold
                </span>
              </div>
            </Col>
            <Col span={12}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",

                  fontWeight: "500",
                  justifyContent: "center",
                  border: `1px solid ${themeJSON.holdAndCancelButtonBGColor || "rgba(146, 144, 152, 0.5)"}`,
                  height: "4.8vh",
                  borderRadius: "5px",
                  cursor: "pointer",
                  backgroundColor: themeJSON.holdAndCancelButtonBGColor || "#fff",
                }}
                id="sm-delete-cart"
                onClick={deleteProductModal}
              >
                <img src={Cancel} style={{ height: "2.5vh" }} />
                <span
                  style={{
                    textAlign: "center",
                    margin: "0",
                    color: themeJSON.holdAndCancelButtonTextColor || "#2F3856",
                    paddingLeft: "0.5vw",
                    fontSize: "1em",
                    fontWeight: 500,
                  }}
                >
                  Cancel
                </span>
              </div>
            </Col>
          </Row>
        </div>
      </div>

      {expandTotals && (
        <Modal
          open={true}
          onCancel={() => setExpandTotals(false)}
          closable={true}
          closeIcon={<CloseOutlined style={{ fontSize: "18px" }} />}
          footer={null}
          width={isExchange ? "60%" : "35%"}
          title={
            <div
              style={{
                fontSize: "1.5vw",
                fontWeight: "600",
                textAlign: "center",
              }}
            >
              {isExchange ? "Exchange Bill Summary" : "Bill Summary"}
            </div>
          }
          centered
          styles={{
            body: {
              padding: "20px",
              background: "#f5f5f5",
              borderRadius: "0 0 8px 8px",
            },
          }}
          maskClosable={false}
        >
          {isExchange ? (
            (() => {
              const exchangeCartData = useCartStore.getState().exchangeCart || {};
              const returnTotal = parseFloat(cart?.total || 0);
              const exchTotal = parseFloat(exchangeCartData?.total || 0);
              const netAmount = returnTotal + exchTotal;
              const summaryRowStyle = { padding: "10px 0", borderBottom: "1px solid #e8e8e8" };
              const labelStyle = { display: "flex", alignItems: "center", paddingLeft: "10px", textAlign: "left", fontWeight: "500", color: "#0F0718", fontSize: "1vw" };
              const valueStyle = { display: "flex", alignItems: "center", justifyContent: "flex-end", paddingRight: "10px", color: "#0F0718", fontWeight: "500", fontSize: "1vw" };
              const currLeft = currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : "";
              const currRight = currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : "";
              const renderValue = (val) => (
                <>
                  {currLeft}
                  <p style={{ margin: "0 5px", textAlign: "right" }}>{val}</p>
                  {currRight}
                </>
              );
              return (
<div
  style={{
    display: "flex",
    flexDirection: "column",
    gap: "12px",
  }}
>
<div
  style={{
    display: "flex",
    gap: "12px",
    alignItems: "stretch",
  }}
>
                  <div style={{ background: "#fff", border: "1px solid #e8e8e8", borderRadius: "8px", padding: "15px", fontSize: "1vw", boxShadow: "0 2px 8px rgba(0,0,0,0.1)", flex: 1, minWidth: 0 }}>
                    <div style={{ fontWeight: 600, marginBottom: "8px", color: "#2F3856" }}>Return Items</div>
                    {[
                      { label: "Subtotal", value: parseFloat(cart?.subTotal ?? 0).toFixed(2) },
                      { label: "Discount", value: parseFloat(cart?.discount || 0).toFixed(2) },
                      { label: "Tax", value: parseFloat(cart?.tax || 0).toFixed(2) },
                      ...(( cart?.tcs || 0) > 0 ? [{ label: "TCS", value: toFixedTruncate(cart?.tcs || 0) }] : []),
                      { label: "Net Value", value: parseFloat(cart?.total ?? 0).toFixed(2) },
                    ].map((item, idx) => (
                      <Row key={idx} style={summaryRowStyle}>
                        <Col span={12} style={labelStyle}>
                          <p style={{ margin: 0 }}>{item.label}:</p>
                        </Col>
                        <Col span={12} style={valueStyle}>
                          {renderValue(item.value)}
                        </Col>
                      </Row>
                    ))}
                  </div>
                  <div style={{ background: "#fff", border: "1px solid #e8e8e8", borderRadius: "8px", padding: "15px", fontSize: "1vw", boxShadow: "0 2px 8px rgba(0,0,0,0.1)", flex: 1, minWidth: 0 }}>
                    <div style={{ fontWeight: 600, marginBottom: "8px", color: "#2F3856" }}>Exchange Items</div>
                    {[
                      { label: "Subtotal", value: parseFloat(exchangeCartData?.subTotal ?? 0).toFixed(2) },
                      { label: "Discount", value: parseFloat(exchangeCartData?.discount || 0).toFixed(2) },
                      { label: "Tax", value: parseFloat(exchangeCartData?.tax || 0).toFixed(2) },
                      ...((exchangeCartData?.tcs || 0) > 0 ? [{ label: "TCS", value: toFixedTruncate(exchangeCartData?.tcs || 0) }] : []),
                      { label: "Net Value", value: parseFloat(exchangeCartData?.total ?? 0).toFixed(2) },
                      {
                        label: "Total Items / Qty",
                        value: `${exchangeCartData?.items?.length || 0} / ${parseFloat(exchangeCartData?.totalQty || 0).toFixed(2)}`,
                        noCurrency: true,
                      },
                    ].map((item, idx) => (
                      <Row key={idx} style={summaryRowStyle}>
                        <Col span={12} style={labelStyle}>
                          <p style={{ margin: 0 }}>{item.label}:</p>
                        </Col>
                        <Col span={12} style={valueStyle}>
                          {item.noCurrency ? <p style={{ margin: "0 5px" }}>{item.value}</p> : renderValue(item.value)}
                        </Col>
                      </Row>
                    ))}
                  </div>
</div>
<div
  style={{
    width: "100%",
    background: "#2F3856",
    border: "none",
    borderRadius: "8px",
    padding: "18px 20px",
    fontSize: "1vw",
    boxSizing: "border-box",
  }}
>
                    <Row>
                      <Col span={12} style={{ ...labelStyle, color: "#fff" }}>
                        <p style={{ margin: 0, fontWeight: 600 }}>{netAmount >= 0 ? "Amount To Pay" : "Refund Amount"}:</p>
                      </Col>
                      <Col span={12} style={{ ...valueStyle, color: "#fff" }}>
                        {currLeft}
                        <p style={{ margin: "0 5px", textAlign: "right", fontWeight: 600, fontSize: "1.2vw" }}>{Math.abs(netAmount).toFixed(2)}</p>
                        {currRight}
                      </Col>
                    </Row>
                  </div>
                </div>
              );
            })()
          ) : (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <div
                style={{
                  background: themeJSON.taxAndDiscountSectionBGColor || "#fff",
                  width: "100%",
                  border: "1px solid #e8e8e8",
                  borderRadius: "8px",
                  padding: "15px",
                  fontSize: "1vw",
                  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                }}
              >
                {[
                  {
                    label: "Subtotal",
                    value: parseFloat(cart?.subTotal ?? 0).toFixed(2),
                  },
                  { label: "Discount", value: parseFloat(cart.discount ? cart.discount : 0).toFixed(2) },
                  { label: "Tax", value: parseFloat(cart.tax).toFixed(2) },
                  ...((cart?.tcs || 0) > 0 ? [{ label: "TCS", value: toFixedTruncate(cart?.tcs || 0) }] : []),
                  { label: "Net Value", value: parseFloat(cart?.total ?? 0).toFixed(2) },
                  { label: "Total Items / Total Qty", value: `${cart.items.length} / ${parseFloat(cart.totalQty).toFixed(2)}`, noCurrency: true },
                ].map((item, index) => (
                  <Row key={index} style={{ padding: "10px 0", borderBottom: index < 8 ? "1px solid #e8e8e8" : "none" }}>
                    <Col
                      span={12}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        paddingLeft: "10px",
                        textAlign: "left",
                        fontWeight: "500",
                        color: "#0F0718",
                        fontSize: "1vw",
                      }}
                    >
                      <p style={{ margin: 0, ...styles.screenStyles.mainScreen.subTotalText }}>{item.label}:</p>
                    </Col>
                    <Col
                      span={12}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "flex-end",
                        paddingRight: "10px",
                        color: "#0F0718",
                        fontWeight: "500",
                        fontSize: "1vw",
                      }}
                    >
                      {!item.noCurrency && <span>{currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}</span>}
                      <p style={{ margin: "0 5px", textAlign: "right" }}>{item.value}</p>
                      {!item.noCurrency && <span>{currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""}</span>}
                    </Col>
                  </Row>
                ))}
              </div>
            </div>
          )}
        </Modal>
      )}
    </>
  );
};

export default SMCartSummary;
